import type {ResourceDisclosure} from '../types';

/** Replaced at render with the group's benefitsContact; defaults to "HR office". */
export const CONTACT_TOKEN = '{contact}';

/** Shared "Required disclosures" for the resource pages, until a site sets its own. */
export const DEFAULT_DISCLOSURES: ResourceDisclosure[] = [
  {
    label: 'COBRA continuation',
    text: `You may continue coverage after a qualifying event. Contact your ${CONTACT_TOKEN} for details and election forms.`,
  },
  {
    label: 'CHIPRA notice',
    text: `Premium-assistance opportunities through Medicaid + CHIP. See your ${CONTACT_TOKEN} for the state-specific notice.`,
  },
  {
    label: 'Medicare Part D',
    text: 'Prescription drug coverage offered through these Plans is non-creditable relative to Part D.',
  },
  {
    label: 'HIPAA Rights',
    text: `Your HIPAA Rights Notice is available from your ${CONTACT_TOKEN}.`,
  },
];

export function siteDisclosures(
  disclosures: ResourceDisclosure[] | undefined,
): ResourceDisclosure[] {
  return disclosures ?? DEFAULT_DISCLOSURES;
}
